import React from 'react';
import styles from './styles.module.scss';
import { Typography } from '@material-ui/core';

interface ComponentProps{
  message : string;
}
export const FormErrorMessage: React.FC<ComponentProps> = ({message}): JSX.Element => {
  return (
    <div className={styles.error}>
      <i className="fa fa-exclamation-circle" aria-hidden={true} />
      <Typography variant="body1" >{message}</Typography>
    </div>
  );
};
